module.exports = __webpack_public_path__ + "media/images/samples/home/ep/ep1@2x-4c42589c415006a2d921e2e8aa7061c0.png";